import { render, staticRenderFns } from "./BottomHero.vue?vue&type=template&id=73ffa21f&"
import script from "./BottomHero.vue?vue&type=script&lang=js&"
export * from "./BottomHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports